<!--
基础表单项组件
title:左侧文案
-->
<template>
  <div
    class="hi-form-item"
    @click="$emit('click')"
    :style="{
      'padding-left': `${paddingLR}px`,
      'padding-right': `${paddingLR}px`,
    }"
    :class="{ 'form-header': type === 'header', select: type === 'select' }"
  >
    <div class="icon-container" v-if="type === 'select'">
      <div class="select-icon" v-if="model"></div>
    </div>
    <div class="left-container" v-if="title || tipMessage">
      <div class="title" :class="{ header: type === 'header' }">
        {{ title }}
      </div>
      <div class="tip-message" v-show="tipMessage">{{ tipMessage }}</div>
    </div>
    <div ref="right" class="right-container" :class="{ readonly, point }">
      <slot>
        <template v-if="type === 'form'">
          <span v-show="!value" class="no-text">None</span>
          <span v-show="value">{{ value }}</span>
        </template>
      </slot>
    </div>
    <div v-if="clickAble" class="click-icon"></div>
  </div>
</template>

<script>
export default {
  name: "FormItemComponent",
  model: {
    prop: "model",
    event: "updateValue",
  },
  props: {
    title: {
      // 左侧标题
      type: String,
      default: "",
    },
    point: {
      type: Boolean,
      default: true,
    },
    model: {
      // 绑定值
      type: [String, Boolean],
      default: "",
    },
    tipMessage: {
      // 标题下方文字
      type: String,
      default: "",
    },
    paddingLR: {
      type: [String, Number],
      default: 20,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clickAble: {
      type: Boolean,
      default: false,
    },
    type: {
      // 类型 默认表单类型(form) 标题(header) select(选择模式)
      type: String,
      default: "form",
    },
  },
  data() {
    return {
      value: this.model,
    };
  },
  watch: {
    value(val) {
      this.$emit("updateValue", val);
    },
    model(val) {
      this.value = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../assets/style/theme.less";

.hi-form-item,
.bulk-form {
  .el-input {
    width: 100% !important;
    background: transparent;
    height: 100%;
  }

  .el-input input {
    border: 0 !important;
    text-align: right !important;
    padding: 0 !important;
    width: 100%;
    color: black;
    background: transparent;
    height: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-input__prefix {
    display: none;
  }

  .el-input__suffix {
    display: none;
  }
}

.bulk-form {
  color: black;

  .right-container {
    color: rgb(90, 90, 90);

    .el-input input {
      color: rgb(90, 90, 90);
    }
  }
}

/*.hi-form-item{*/
/*.el-input input {*/
/*font-size: 14px;*/
/*line-height: 14px;*/
/*}*/
/*}*/
/*.bulk-form {*/
/*.el-input input {*/
/*font-size: 12px;*/
/*line-height: 12px;*/
/*}*/
/*}*/
</style>
<style scoped lang="less">
@import "../../../assets/style/theme.less";

.hi-form-item {
  display: flex;
  font-size: 14px;
  border-bottom: 1px solid @border-color;
  min-height: 44px;
  align-items: center;
  padding: 5px 20px;

  &.form-header {
    font-weight: 500;
  }

  &.select:hover {
    opacity: 0.7;
    cursor: pointer;
  }

  .icon-container {
    width: 16px;
    height: 16px;
    margin-right: 10px;

    .select-icon {
      width: 16px;
      height: 16px;
      background-size: contain;
      background-image: url("../../../../public/images/setting/select_2@3x.png");
    }
  }

  .left-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    .title {
      font-size: 14px;
    }

    .tip-message {
      color: @font-color-gray;
      font-size: 11px;
      margin-top: 2px;
    }
  }

  .right-container {
    text-align: right;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
    color: #606266;
    font-size: 14px;
    flex: 1;
    &.readonly {
      opacity: 0.3;
    }

    &.point {
      cursor: pointer;
    }

    &.readonly.point {
      cursor: initial;
    }

    .no-text {
      color: #cbced5;
      font-weight: normal;
    }
  }

  .click-icon {
    width: 8px;
    height: 14px;
    background-image: url("../../../../public/images/schedule_posts/Date_Right@3x.png");
    background-size: contain;
    margin-left: 5px;
    position: relative;
    top: 1px;
  }
}
</style>
